import { withI18n } from 'react-i18next';
import PartClaimView from './PartClaimView';

export const pureComponent = PartClaimView;
export default withI18n()(PartClaimView);
